import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'apnst-formly-field-text',
  templateUrl: './formly-field-text.component.html',
  styleUrls: ['./formly-field-text.component.css']
})
export class FormlyFieldTextComponent extends FieldType {
  onClick(event: any) {
    if (this.to.onClick) {
      this.to.onClick(event);
    }
  }
}
